import React from 'react'

import _modules from '../../_modules'

const EquipmentsDetail = React.lazy(() => import('./views/equipments/EquipmentsDetail'))
const Equipments = React.lazy(() => import('./views/equipments/Equipments'))

const ProjectsDetail = React.lazy(() => import('./views/projects/ProjectsDetail'))
const Projects = React.lazy(() => import('./views/projects/Projects'))

const ProjectTypesDetail = React.lazy(() => import('./views/projectTypes/ProjectTypesDetail'))
const ProjectTypes = React.lazy(() => import('./views/projectTypes/ProjectTypes'))

const _routes = []

if (_modules.equipments)
  _routes.push(
    ...[
      {
        path: '/equipments/:id',
        name: 'Equipment Detail',
        component: EquipmentsDetail,
      },
      { path: '/equipments', name: 'Equipments', component: Equipments },
    ],
  )
if (_modules.projects) {
  _routes.push(
    ...[
      {
        path: '/projects/:id',
        name: 'Project Detail',
        component: ProjectsDetail,
      },
      { path: '/projects', name: 'Projects', component: Projects },
    ],
  )
  _routes.push(
    ...[
      {
        path: '/project-types/:id',
        name: 'Project Type Detail',
        component: ProjectTypesDetail,
      },
      { path: '/project-types', name: 'Project Types', component: ProjectTypes },
    ],
  )
}

export default _routes
